/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useCurrentDynamicField } from "cms/fields/dynamic-field/index";
import { ListItemContext } from "cms/fields/field-lists/field-list-context";
import { useContext, useEffect, useState } from "react";
import { UpDownButtons } from "cms/fields/field-lists/updown-buttons";
import { Logger } from "cms/utils/log/logger";

const PositionButtons = (props) => {
    
    const currentIndex = props?.currentIndex;
    const ctx = useContext(ListItemContext);
    const { field } = useCurrentDynamicField();

    const values = field?.values;
    const count = values?.length;
    const [position, setPosition] = useState(currentIndex);

    useEffect(() => {
        setPosition(currentIndex);
    }, [currentIndex]);

    const last_index = count - 1;
    const isSingle = count === 1;
    const isFirst = position === 0 && !isSingle;
    const isLast = position === last_index && !isSingle;

    const moveUp = (event) => {
        event.stopPropagation();
        Logger.debug("moveUp");
        changePosition(event, "up", position);
    };
    
    const moveDown = (event) => {
        event.stopPropagation();
        Logger.debug("moveDown");
        changePosition(event, "down", position);
    };
    
    const noMove = (event) => {
        event.stopPropagation();
    };

    const defaultProps = {
        handleUp: moveUp,
        handleDown: moveDown,
    };

    const changePosition = (e, direction, position) => {
        Logger.debug(`changePosition ${direction} ${position} `);
        const count = values ? values.length : 0;
        const last_pos = count - 1;
        const isLast = position === last_pos;
        const isFirst = position === 0;
        let target_position;

        if (isFirst) {
            target_position = direction === "up" ? 0 : position + 1;
        } else if (isLast) {
            target_position = direction === "down" ? last_pos : position - 1;
        } else {
            target_position = direction === "up" ? position - 1 : position + 1;
        }
        const params = { position, direction, target_position };
        ctx.changePositions(params);
    };

    const firstProps = { ...defaultProps, handleUp: noMove, upDisabled: true };
    const lastProps = { ...defaultProps, handleDown: noMove, downDisabled: true };

    const activeProps = isFirst ? firstProps : isLast ? lastProps : defaultProps;

    return (
        <>
            <UpDownButtons count={count} {...activeProps} />
        </>
    );
};

PositionButtons.displayName = "PositionButtons";
export { PositionButtons };
